import React from "react";

import ContainerLandpage from "containers/Landpage";

// Landing 2026 (componente único, mobile-first, foco em conversão).
// A versão anterior (Topo/ModosExplicacao/PqAssinar/Planos/FaleConosco)
// segue intacta em components/Landpage/* caso precise voltar.
import LandpageNova from "components/Landpage/Nova";

export default function Landpage(){

    return (
        <ContainerLandpage>
            <LandpageNova />
        </ContainerLandpage>
    );
}
